/* Product - change label size buttons */
/* -------------------------------------------------------------------------------------- */

const size_crocs = ["M4W6", "M5W7", "M6W8", "M7W9", "M8W10", "M9W11", "M10W12", "M11", "M12", "M13", "W4", "W5", "W6", "W7", "W8", "W9", "W10", "W11", "W12", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9", "M10", "M11", "M12", "M13", "M14", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13", "J1", "J2", "J3", "J4", "J5", "J6"]
const size_mx = ["22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "21", "22", "23", "24", "25", "26", "27", "28", "29", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26"]

// change normal product
$('body').on('click', '.js-change-size', function(event) {
    const labels = document.querySelectorAll('.js-change-size-label')

    if( this.dataset.size_type != 'size-crocs' ){
      change_label(size_crocs,labels,size_mx);
    }else{
      change_label_original(labels);
    }
});

// change quick product
$('body').on('click', '.js-quick-change-size', function(event) {
    const labels = document.querySelectorAll('.js-quick-change-size-label')

    if( this.dataset.size_type != 'size-crocs' ){
      change_label(size_crocs,labels,size_mx);
    }else{
      change_label_original(labels);
    }
});

function change_label(list, labels, list_change){
    labels.forEach(label => {
        list.forEach((li, index) => {
            if(`${li}` == `${label.innerHTML}`){
              label.innerHTML = list_change[index];
            }
        });
    });
}
function change_label_original(labels){
    labels.forEach(label => {
        label.innerHTML = label.dataset.size_crocs;
    });
}

















